import { SecondaryStatusTag } from "@graffer-inc/console-design-kit";
import * as React from "react";

export const GrafferManagedTag: React.FC = () => {
  return <SecondaryStatusTag type={"PRIMARY"}>Graffer管理</SecondaryStatusTag>;
};
